
import { defineComponent } from "vue";

export default defineComponent({
  name: "Heading4",
  props: {
    alignment: {
      type: String,
      validator(value: string) {
        return ["centered"].includes(value);
      },
    },
  },
});
